var wgstuImg = document.getElementById('wgstu');

//If window is mobile size. Change image source of WGSTU
function checkwgstu() {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
  if (windowWidth <= 768) {
    wgstuImg.setAttribute('src', '/wp-content/themes/FirstBase/assets/img/graphics/Wgstu_m.svg');
  } else {
    wgstuImg.setAttribute('src', '/wp-content/themes/FirstBase/assets/img/graphics/Wgstu.svg');
  }
}
//checkwgstu();

/*--------------------------*/
/*    VIDEO CONTROL	    	*/
/*--------------------------*/

var frameNumber = 0,
  vid = document.getElementById('screw_vid'),
  vidStop = false;

function getScrollPos(max = document.documentElement.scrollHeight) {
  const { scrollY } = window;

  return rangeMapper(scrollY, 0, max, 0, 100);
}

// Use requestAnimationFrame for smooth playback
function scrollPlay() {
  //Determine frame number based on video duration and scroll percentage
  var frameNumber = rangeMapper(getScrollPos(750), 0, 100, 0, vid.duration);

  //Check if frame number is a number, else set to 0
  if (isNaN(frameNumber)) {
    frameNumber = 0;
  }
  if (frameNumber >= vid.duration - 0.5) {
    frameNumber = vid.duration - 0.5;
  }
  //console.log('framenumber = ' + frameNumber + '  |||||  ' + rangeMapper(getScrollPercent(), 0, 95, 0, vid.duration) + '  |||||  ' + vid.currentTime);
  //Set current time to frame number
  vid.currentTime = frameNumber;

  if (!vidStop) {
    window.requestAnimationFrame(scrollPlay);
  }
}

if (vid) {
  vid.addEventListener('loadedmetadata', function () {
    window.requestAnimationFrame(scrollPlay);
  });
}

//Range mapper function used for setting video playback
function rangeMapper(num, in_min, in_max, out_min, out_max) {
  return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

//Get current scroll percentage
function getScrollPercent() {
  var h = document.documentElement,
    b = document.body,
    st = 'scrollTop',
    sh = 'scrollHeight';
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
}

/*--------------------------*/
/*    SAFARI OVERSCROLL   	*/
/*--------------------------*/

var heroTarget = document.querySelector('.landing .rellax:first-of-type'),
  heroImages = document.querySelectorAll('.landing .rellax');

var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutationRecord) {
    if (getScrollPercent() <= 0) {
      for (var i = 0; i < heroImages.length; i++) {
        heroImages[i].style.transform = 'translate3d(0,0,0)';
      }
    }
  });
});

if (heroTarget) {
  observer.observe(heroTarget, {
    attributes: true,
    attributeFilter: ['style'],
  });
}

/*--------------------------*/
/*    SAFARI BG COLOR	  	*/
/*--------------------------*/
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

document.addEventListener('DOMContentLoaded', function () {
  if (isSafari) {
    document.body.classList.add('isWebKit');
  }
});

var nfHelpEle = document.getElementsByClassName('nf-help');
jQuery(document).ready(function () {
  if (nfHelpEle) {
    for (var i = 0; i < nfHelpEle.length; i++) {
      nfHelpEle[i].addEventListener('mouseleave', function (e) {
        removeElementsByClass('jBox-wrapper');
      });
    }
  }
});

function removeElementsByClass(className) {
  var elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
}
